import { Typography } from '@mui/material';
import React from 'react';

interface DetailCaptionProps {
  children: React.ReactNode;
}

function DetailCaption({ children }: DetailCaptionProps) {
  return (
    <div style={{ margin: '5px 0px' }}>
      <Typography variant="subtitle1" color="#7a1414">
        {children}
      </Typography>
    </div>
  );
}

export default DetailCaption;
